<template>
<div>
    <div class="notify">
        <h2 class="notify-title">账号绑定</h2>
        <div class="notify-group">
            <span class="ico-suc" v-show="showSuc"></span>
            <span class="ico-fail" v-show="!showSuc"></span>
        </div>
        <div class="notify-content">
            <p class="notify-text" v-show="showSuc">恭喜你绑定账号成功，快去参加活动吧！</p>
            <p class="notify-text" v-show="!showSuc">{{faliText}}</p>
        </div>
    </div>
</div>
</template>

<style lang="scss" scoped>
    @import "~Assets/sass/pages/account/notify.scss";
</style>


<script>
import store from 'Stores';
export default {
    data(){
        return{
            showSuc: false,
            faliText: ''
        }
    },
    mounted(){
        if(this.$route.params.status == 'fail'){
            switch(this.$route.query.code){
            case '40000':
                this.faliText = '媒体不存在'
                break;
            case '40002':
                this.faliText = '授权失败'
                break;
            case '40003':
                this.faliText = '该帐号已被其他用户绑定'
                break;
            case '40006':
                this.faliText = '企鹅号未绑定QQ管理员账户，无法上传视频'
                break;
            case '40007':
                this.faliText = '您的帐号还未通过百家号认证'
                break;
            default:
                this.faliText = `${this.$route.query.code}:绑定失败`;
                break;
               
            }
        }else{
            this.showSuc=true;
            store.dispatch({
                type: 'getUserMediaAccounts'
            });
        }
    }
}
</script>

